// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'
// import { BooleanGenericResponse, AddTrafficUnitUserDTO, Int32GenericResponse } from 'types/ApiTypes'
// Define a service using a base URL and expected endpoints
interface IParam {
  [key: string]: string
}
export const ConfigurationsAPI = createApi({
  reducerPath: 'ConfigurationsAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Configurations'],
  endpoints: builder => ({
    getConfiguration: builder.query({
      query: name => ({
        method: 'GET',
        url: `/${name}`,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Configurations'],
    }),
    getDynamicConfiguration: builder.query<any, any>({
      query: data => ({
        method: 'GET',
        url: `/${data.name}`,
        params: data.params,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Configurations'],
    }),
    deleteDynamicConfiguration: builder.mutation<any, string>({
      query: url => ({
        method: 'DELETE',
        url: `/${url}`,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Configurations'],
    }),

    postDynamicConfiguration: builder.mutation<any | any, any>({
      query: data => ({
        url: `/${data.url}`,
        method: 'POST',
        body: data.body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Configurations'],
    }),

    updateDynamicConfiguration: builder.mutation<any | any, any>({
      query: data => ({
        method: 'PUT',
        url: `/${data.url}`,
        headers: authHeaderAPI(),
        body: data.body,
      }),
      invalidatesTags: ['Configurations'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
export const {
  useGetConfigurationQuery,
  useGetDynamicConfigurationQuery,
  useDeleteDynamicConfigurationMutation,
  usePostDynamicConfigurationMutation,
  useUpdateDynamicConfigurationMutation,
} = ConfigurationsAPI
